import React from 'react';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import { typo, pageHeaderSx, colors } from '../../theme/tokens';

interface PageHeaderProps {
  title: string;
  subtitle?: React.ReactNode;
  actions?: React.ReactNode;
}

export default function PageHeader({ title, subtitle, actions }: PageHeaderProps) {
  return (
    <Box sx={pageHeaderSx}>
      <Box>
        <Typography sx={typo.pageTitle}>{title}</Typography>
        {/* Accent bar under title */}
        <Box
          sx={{
            width: 48,
            height: 4,
            borderRadius: '2px',
            background: `linear-gradient(90deg, ${colors.brand} 0%, rgba(250,179,6,0.3) 100%)`,
            mt: 1,
            mb: 0.5,
          }}
        />
        {subtitle && (
          <Typography sx={{ ...typo.pageSubtitle, mt: 0.5 }}>
            {subtitle}
          </Typography>
        )}
      </Box>
      {actions && (
        <Box sx={{ display: 'flex', gap: 1.5, flexShrink: 0 }}>{actions}</Box>
      )}
    </Box>
  );
}
